module.exports = __webpack_public_path__ + "img/menu.590f7a38.svg";